module.exports = "https://cdn.realtymogul.com/static/media/Triangle.38c61ee2.svg";